module.exports = __webpack_public_path__ + "img/deposit.0c41e809.jpg";